<template>
  <div class="sticky-margin"></div>
  <div class="sticky-placeholder" ref="placeHolder"></div>
  <div class="product-sticky" ref="sticky" :class="{'phone-only': !(phone.defaults.subscription), 'sticky-bottom': stickyBottom, 'sticky-top' : stickyTop }" v-if="phone">
    <Loader v-if="load"/>
    <div class="phone">
      <div class="icon"><span class="fi-rr-smartphone"></span></div>
      <div class="data">
        <div class="data__inner">
          <h3>{{ phone.name }}</h3>
          <p class="small fraxio" v-if="phone.defaults.subscription && phone.fraxio.price">+{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(phone.fraxio.price) }} / mois pendant {{ phone.fraxio.formated_duration }}</p>
          <p class="small grey">Dont 0,05€ d'éco participation</p>
        </div>
      </div>
      <div class="price">
        <p v-html="phone.prices.display" v-if="phone.defaults.subscription"></p>
        <p v-html="phone.prices.alone" v-else></p>
      </div>
    </div>
    <div class="more" v-if="phone.defaults.subscription">
      <span>+</span>
    </div>
    <div class="subscription" v-if="phone.defaults.subscription">
      <div class="icon"><span class="fi-rr-sim-card"></span></div>
      <div class="data">
        <div class="data__inner">
          <h3>{{ subscription.libellePublic }}</h3>
          <p class="small" v-if="subscription.prixInitial > subscription.prixMajore">Pendant {{ subscription.promoDuration }} puis <span v-html="subscription.prices.initial"></span></p>
          <p class="small">Engagement {{ subscription.commitment }}</p>
        </div>
      </div>
      <div class="price">
        <p v-if="subscription.prixInitial > subscription.prixMajore"><span v-html="subscription.prices.regular"></span></p>
        <p v-else><span v-html="subscription.prices.initial"></span></p>
      </div>
    </div>
    <div class="button">
      <a href="" class="btn btn-primary btn-small out-of-stock" @click.prevent="" v-if="selectedStore && selectedStore.stock === 0 && !stockLoading">Téléphone indisponible</a>
    </div>
  </div>
  <div class="sticky-data" v-if="phone">
    <div class="inner">
      <p>Prix à payer en magasin: <span class="price">{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(phone.prices_floats.store) }}</span></p>
      <p v-if="phone.prices_floats.discount > 1 && phoneHasOffers">Puis <span>-{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(phone.prices_floats.discount) }}</span> remboursés après achat</p>
      <p><a href="" @click.prevent="openPopup">Détails</a></p>
    </div>
  </div>
</template>

<script>
import Loader from './Loader'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Sticky',
  data () {
    return {
      stickyTop: false,
      stickyBottom: false,
      scrollPosition: null
    }
  },
  mounted () {

    const height = window.innerHeight
    const placeHolder = this.$refs.placeHolder.getBoundingClientRect()

    if(placeHolder.top > height) {
      this.stickyBottom = true
    }

    document.addEventListener('scroll', (e) => {
      const windowHeight = window.innerHeight
      const windowWidth = window.innerWidth
      const placeHolder = this.$refs.placeHolder.getBoundingClientRect()
      const sticky = (this.$refs.sticky) ? this.$refs.sticky.getBoundingClientRect() : null
      const stickyHeight = (sticky) ? sticky.height : 0

      const stickyTopPosition = Math.round(placeHolder.top - windowHeight + Math.round(stickyHeight))

      if(stickyTopPosition < 0 ) {
        this.stickyTop = false
        this.stickyBottom = false
        this.$refs.placeHolder.style.height = '0px'
      } else {
        this.stickyTop = false
        this.stickyBottom = true
        this.$refs.placeHolder.style.height = stickyHeight + 'px'
      }

      if(Math.round(placeHolder.top) < 10 && windowWidth >= 700){
        this.stickyTop = true
        this.stickyBottom = false
        this.$refs.placeHolder.style.height = stickyHeight + 'px'
      }

    })

  },
  computed: {
    ...mapState({
      stockLoading: state => state.stores.stockLoading,
      selectedCode: state => state.stores.selected,
      stores: state => state.stores.items,
      phone: state => state.phone.item,
      buttonName: state => state.phone.button,
      load: state => state.phone.loading
    }),
    currentColor () {
      let currentColor = 'FFFFFF'

      this.phone.defaults.color
      this.phone.colors.forEach((color) => {
        if(color.id === this.phone.defaults.color.id) currentColor = color.hex
      })

      return currentColor
    },
    subscription () {
      return this.phone.defaults.subscription
    },
    selectedStore () {
      let selectedStore = null

      this.stores.forEach((store) => {
        if(store.code === this.selectedCode) {
          selectedStore = store
        }
      })

      return selectedStore
    },
    phoneHasOffers () {
      const offers = []
      if(this.phone.offers && this.phone.offers.length) {
        this.phone.offers.forEach((offer) => {
          if (offer.typePromotion.nom === 'ODR' || offer.typePromotion.nom === 'FLASH' || offer.typePromotion.nom === 'ODR Assu' || offer.typePromotion.nom === 'Flash Assu') offers.push(offer)
        })
      }
      return !!(offers.length)
    },
    phoneNotAlone () {
      return !!(this.phone.defaults.subscription)
    }
  },
  methods: {
    ...mapActions('phone', ['saveEstimate']),
    ...mapActions('prices', ['openPopup']),
    saveEstimateTracking () {

      this.saveEstimate()

    }
  },
  components: {
    Loader
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.sticky-placeholder, .sticky-margin{
  grid-column: span 2;
}

.sticky-margin{
  margin: 30px 0 0 0;
}

.sticky-data{
  grid-column: span 2;
  padding: 0 10px;

  .inner{
    padding: 30px 60px;
    background-color: $white;
    @include radius(10px, 'bottom');
    @include box-shadow(0, 1px, 3px, rgba($black, 0.1));

    @include responsive(mobile){
      padding: 15px;
    }

    p{
      font-size: px2rem(14px);
      line-height: px2rem(19px);
      font-weight: $fontMedium;
      margin-bottom: 3px;

      &:last-child{
        margin-bottom: 0;
      }

      span, a{
        color: $primary;
      }

      a{
        text-decoration: underline;
      }

      @include responsive(mobile) {
        font-size: px2rem(12px);
        line-height: px2rem(18px);
      }
    }
  }
}

.product-sticky{
  display: grid;
  grid-template-columns: auto auto 1fr auto;
  grid-column-gap: 30px;
  background-color: $white;
  padding: 20px 30px;
  min-height: 140px;
  width: 100%;
  max-width: $containerSize;
  z-index: 1000;
  grid-column: span 2;
  position: relative;
  overflow: hidden;
  @include radius(10px);
  @include box-shadow(0, 1px, 3px, rgba($black, 0.1));

  @include responsive(mobile) {
    padding: 20px;
    grid-template-columns: 1fr;
    grid-row-gap: 10px;
  }

  &.sticky-bottom{
    position: fixed;
    bottom: 10px;
    left: 50%;
    margin: 0;
    @include transform(translateX(-50%) translateZ(0));

    @include responsive(mobile) {
      bottom: 0;
      width: calc(100vw - 40px);
      @include radius(0);
      @include radius(10px, 'top');
    }
  }

  &.sticky-top{
    position: fixed;
    top: 10px;
    left: 50%;
    margin: 0;
    @include box-shadow(0, 1px, 3px, rgba($black, 0.1));
    @include transform(translateX(-50%) translateZ(0));

    @include responsive(mobile) {
      top: 0;
      width: calc(100vw - 40px);
      @include radius(0);
      @include radius(10px, 'bottom');
      @include transform(translateX(-50%) translateY(86px) translateZ(0));
    }
  }

  &.phone-only{
    grid-template-columns: 1fr auto;

    @include responsive(mobile){
      grid-template-columns: 1fr;
    }
  }

  .more{
    display: flex;
    align-items: center;
    justify-content: center;

    @include responsive(mobile) {
      display: none;
    }

    span{
      display: inline-block;
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: darken($white, 5%);
      font-size: 22px;
      padding: 1px 0 0 1px;
      @include box-sizing();
      @include radius(100%);
    }
  }

  .subscription, .phone{
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-column-gap: 30px;

    @include responsive(mobile) {
      grid-template-columns: 1fr auto;
    }

    .data, .icon{
      display: flex;
      align-items: center;
    }

    .icon{
      justify-content: center;
      font-size: px2rem(32px);

      @include responsive(mobile) {
        display: none;
      }
    }

    .data{
      h3{
        line-height: 1.20rem;
        margin-bottom: 5px;

        @include responsive(mobile) {
          font-size: px2rem(12px);
          line-height: px2rem(18px);
        }
      }

      p{
        display: block;
        width: auto;
        font-size: px2rem(14px);
        line-height: px2rem(20px);
        color: rgba($black, 0.8);
        text-transform: capitalize;

        span.price{
          font-weight: $fontSemiBold;
        }

        sub{
          vertical-align: top;
        }

        &.small{
          font-size: px2rem(12px);
          line-height: px2rem(18px);
          text-transform: none;

          @include responsive(mobile) {
            font-size: px2rem(10px);
            line-height: px2rem(16px);
          }

          &.grey{
            color: rgba($black, 0.5);
          }
        }
      }
    }
  }

  .phone{
    div.price{
      display: flex;
      align-items: center;
      justify-content: center;

      p{
        color: $primary;
        font-weight: $fontSemiBold;
        font-size: px2rem(30px);

        @include responsive(mobile) {
          font-size: px2rem(22px);
        }
      }
    }
  }

  .subscription{

    div.price{
      display: flex;
      align-items: center;
      justify-content: center;

      p{
        color: $primary;
        font-weight: $fontSemiBold;
        font-size: px2rem(30px);
        position: relative;

        @include responsive(mobile) {
          font-size: px2rem(22px);
        }
      }
    }
  }

  .button{
    display: flex;
    align-items: center;
    justify-content: center;

    a.btn{
      &.out-of-stock{
        background-color: $red;
        color: $white;
      }
    }
  }
}
</style>

<style lang="scss">
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.product-sticky{
  .phone{
    div.price{
      sub{
        display: inline-block;
        vertical-align: top;
        font-size: px2rem(20px);
        @include transform(translateY(2px));

        @include responsive(mobile) {
          font-size: px2rem(14px);
        }
      }
    }
  }

  .subscription{
    div.price{
      span.price{
        display: inline-block;
        position: relative;
        padding-right: 5px;

        sub{
          display: inline-block;
          vertical-align: top;
          font-size: px2rem(16px);
          @include transform(translateY(0px));
        }

        span{
          position: absolute;
          bottom: 3px;
          right: -9px;
          font-weight: $fontRegular;
          font-size: px2rem(10px);

          @include responsive(mobile) {
            bottom: -4px;
          }
        }
      }
    }
  }
}
</style>
